<div id="learn-page">
  <div [hidden]="isLearnDataLoaded" class="spinner-container">
    <div class="d-flex justify-content-center">
      <div class="spinner-border custom-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  <div [hidden]="!isLearnDataLoaded" id="learn-page" class="page-body-content">
    <div class="learn-top-band" [ngClass]="{ 'locked-down': isShowingEmptyState(), 'elevate-user': swooshText.length }">
      <div class="container">
        <div class="learn-heading" *ngIf="!isShowingEmptyState()">
          Get started by selecting a course below.
          <div class="heading">
            <a href="{{ swooshExternal }}"
              ><img src="assets/images/icons/arrow-left.svg" class="arrow-left" *ngIf="swooshText.length" /> {{ swooshText }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="container" *ngIf="!isShowingEmptyState(); else lockedDownView">
      <div class="row flex-column-reverse flex-lg-row flex-xl-row">
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 justify-content-start">
          <div *ngFor="let category of categories" class="category-list">
            <div class="d-flex category-heading">
              <div class="category-name">{{ category.categoryName }}</div>
              <div *ngIf="category.isUserSelected" class="category-selected">Recommended</div>
            </div>
            <!-- Desktop & Tablet - Course Section -->
            <div class="category-details d-xl-block d-lg-block d-md-block d-none">
              <div class="course-list" *ngFor="let course of category.courses">
                <div *ngIf="course.isCompleted" class="success-image d-xl-none d-lg-none d-md-block"><span>&#10003;</span></div>
                <div class="d-flex course-info">
                  <div class="course-image"><img src="{{ course.imageUrl }}" /></div>
                  <div class="course-details">
                    <div class="course-name">{{ course.courseName }}</div>
                    <div class="course-description" [innerHtml]="course.description | safeHtml"></div>
                  </div>
                  <div class="course-action">
                    <div *ngIf="course.isCompleted" class="success-image d-xl-block d-lg-block d-md-none"><span>&#10003;</span></div>
                    <a
                      [routerLink]="['/course']"
                      [queryParams]="{ courseId: course.courseId }"
                      *ngIf="course.isCompleted"
                      class="primary-forward-link"
                      >Revisit</a
                    >
                    <button
                      [routerLink]="['/course']"
                      [queryParams]="{ courseId: course.courseId }"
                      *ngIf="!course.isCompleted"
                      [ngClass]="course.isStarted ? 'btn-primary' : 'btn-outline-primary'"
                    >
                      {{ course.isStarted ? 'Resume' : 'Start' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Mobile - Course Section -->
            <div class="category-details d-xl-none d-lg-none d-md-none d-block">
              <div class="course-list" *ngFor="let course of category.courses">
                <div *ngIf="course.isCompleted" class="success-image"><span>&#10003;</span></div>
                <div class="course-action">
                  <a [routerLink]="['/course']" [queryParams]="{ courseId: course.courseId }" *ngIf="course.isCompleted" class="primary-forward-link"
                    >Revisit</a
                  >
                  <button
                    [routerLink]="['/course']"
                    [queryParams]="{ courseId: course.courseId }"
                    *ngIf="!course.isCompleted"
                    [ngClass]="course.isStarted ? 'btn-primary' : 'btn-outline-primary'"
                  >
                    {{ course.isStarted ? 'Resume' : 'Start' }}
                  </button>
                </div>
                <div class="d-flex col-12 course-info">
                  <div class="course-image">
                    <img class="" src="{{ course.imageUrl }}" />
                  </div>
                  <div class="course-details">
                    <div class="course-name">{{ course.courseName }}</div>
                  </div>
                </div>
                <div class="course-details-sm">
                  <div class="course-description" [innerHtml]="course.description | safeHtml"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-12 col-sm-12 justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-center justify-content-center"
        >
          <div class="dashboard-content-section">
            <!-- Desktop - Progress Section -->
            <div class="row d-xl-block d-lg-block d-none">
              <div class="course-progress-bar">
                <div class="barOverflow">
                  <div class="bar"></div>
                </div>
                <div class="course-completed">{{ totalCompletedTopics }}/{{ totalTopics }}</div>
                <div class="course-complete-text">Complete</div>
              </div>
              <div class="course-progress-copy">
                Learn how to boost your confidence, find your motivation, and more. Complete courses to unlock additional tips and everyday guidance
                for your personality type.
              </div>
            </div>
            <!-- Tablet - Progress Section -->
            <div class="row d-md-block d-xl-none d-lg-none d-none">
              <div class="course-progress-copy col-md-7 justify-content-md-start">
                Learn how to boost your confidence, find your motivation, and more. Complete courses to unlock additional tips and everyday guidance
                for your personality type.
              </div>
              <div class="course-progress-bar col-md-5 justify-content-md-center">
                <div class="barOverflow">
                  <div class="bar"></div>
                </div>
                <div class="course-completed mobile-devices">
                  <span class="completed">{{ totalCompletedTopics }}</span
                  >/{{ totalTopics }}
                </div>
                <div class="course-complete-text">Courses Complete</div>
              </div>
            </div>
            <!-- Mobile - Progress Section -->
            <div class="row d-sm-block d-xs-block d-md-none">
              <div class="course-progress-copy justify-content-md-start">
                Learn how to boost your confidence, find your motivation, and more. Complete courses to unlock additional tips and everyday guidance
                for your personality type.
              </div>
              <div class="course-progress-bar d-flex">
                <div class="col-3">
                  <div class="course-completed mobile-devices">
                    <span class="completed">{{ totalCompletedTopics }}</span
                    >/{{ totalTopics }}
                  </div>
                  <div class="course-complete-text">Courses Complete</div>
                </div>
                <div class="col-8">
                  <div class="progress">
                    <div id="progress-bar" [style.width.%]="percentageCompleted" class="progress-bar"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Desktop - MBTI Section -->
            <div class="row d-xl-block d-lg-block d-none">
              <div class="course-type">
                <div class="course-type-diamond-shape">
                  <div class="course-mbtitype">{{ mbtiType }}</div>
                </div>
              </div>
              <div class="course-mbtitype-heading">{{ tagLine }}</div>
              <div class="course-mbtitype-copy">{{ strengths }} <a [routerLink]="['/results']" class="view-results-link">View results »</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #lockedDownView>
    <div class="lockdown-section container">
      <div class="lockdown-header">
        <div class="">Courses</div>
        <img src="/assets/images/lock.svg" />
      </div>
      <div class="lockdown-description">
        <div class="">Finish your assessments to access this area</div>
      </div>
      <div class="padding-buttons complete">
        <button class="btn-primary" (click)="unlock()">Start Now</button>
      </div>
    </div>
  </ng-template>
</div>
